var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9 18H2.85V5.68421H1.9C1.39609 5.68421 0.912816 5.88383 0.556497 6.23917C0.200178 6.5945 0 7.07643 0 7.57895V16.1053C0 16.6078 0.200178 17.0897 0.556497 17.445C0.912816 17.8004 1.39609 18 1.9 18ZM17.1 5.68421H10.45L11.5159 2.49347C11.611 2.20871 11.6369 1.90549 11.5915 1.60878C11.5461 1.31207 11.4306 1.03037 11.2546 0.786879C11.0786 0.543388 10.8472 0.345071 10.5793 0.208265C10.3114 0.0714594 10.0147 7.77911e-05 9.71375 0H9.5L4.75 5.15179V18H15.2L18.9164 9.85642L19 9.47368V7.57895C19 7.07643 18.7998 6.5945 18.4435 6.23917C18.0872 5.88383 17.6039 5.68421 17.1 5.68421Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.3f49eddb381ce0330917bcf43271a9a2.svg";
export { ForwardRef as ReactComponent };